export const customFormList = [
  {
    title: "custom-jumbo-form-control-title",
    text: "custom-jumbo-form-control-text",
    image: "control",
  },
  {
    title: "custom-jumbo-form-marketing-title",
    text: "custom-jumbo-form-marketing-text",
    image: "marketing",
  },
  {
    title: "custom-jumbo-form-notification-title",
    text: "custom-jumbo-form-notification-text",
    image: "notification",
  },
];

export const feedbackList = [
  {
    userName: "data-print-feedback-title",
    businessType: "data-print-business-type",
    userImage: "Dataprint",
    feedback: "data-print-feedback-text",
    feedbackUrl: "https://www.uaglass.com",
    ext: "jpg",
  },
  {
    userName: "sound-clear-feedback-title",
    businessType: "record-studio-business-type",
    userImage: "SoundClear",
    feedback: "sound-clear-feedback-text",
    feedbackUrl: "https://www.soundclear.co.il",
    ext: "jpg",
  },
  {
    userName: "moon-cpa-feedback-title",
    businessType: "accountent-business-type",
    userImage: "MoonCpa",
    feedback: "moon-cpa-feedback-text",
    feedbackUrl: "",
    ext: "png",
  },
  {
    userName: "john-wallas-feedback-title",
    businessType: "video-editor-business-type",
    userImage: "Video Editor",
    feedback: "john-wallas-feedback-text",
    feedbackUrl: "",
    ext: "png",
  },
  {
    userName: "foxy-music-feedback-title",
    businessType: "dj-business-type",
    userImage: "FoxyMusic",
    feedback: "foxy-music-feedback-text",
    feedbackUrl: "",
    ext: "jpg",
  },
  {
    userName: "karen-cohen-feedback-title",
    businessType: "school-business-type",
    userImage: "graduation-cap-duotone",
    feedback: "karen-cohen-feedback-text",
    feedbackUrl: "",
    ext: "svg",
  },
  {
    userName: "avi-perspective-feedback-title",
    businessType: "graphic-designer-business-type",
    userImage: "avi",
    feedback: "avi-perspective-feedback-text",
    feedbackUrl: "https://www.perspective-media.me/",
    ext: "png",
  },
];

export const formFeaturesList = [
  {
    title: "API",
    text: "form-feature-api-text",
    image: "api-icon",
  },
  {
    title: "form-feature-file-format-title",
    text: "form-feature-file-format-text",
    image: "files-format-icon",
  },
  {
    title: "FTP",
    text: "form-feature-ftp-text",
    image: "ftp-icon",
  },
  {
    title: "form-feature-landing-page-title",
    text: "form-feature-landing-page-text",
    image: "landing-icon",
  },
  {
    title: "form-feature-delete-files-title",
    text: "form-feature-deleting-files-text",
    image: "auto-delete",
  },
  {
    title: "form-feature-files-sizes-title",
    text: "form-feature-files-sizes-text",
    image: "receiving-files-icon",
  },
  {
    title: "form-feature-password-protection-title",
    text: "form-feature-password-protection-text",
    image: "password-protection-icon",
  },
  {
    title: "form-feature-storage-title",
    text: "form-feature-storage-text",
    image: "storage-icon",
  },
  {
    title: "form-feature-order-tracker-title",
    text: "form-feature-order-tracker-text",
    image: "order-tracker-icon",
  },
];

export const examplePagesListEn = [
  {
    title: "forms-demo-title-1",
    description: "forms-demo-description-1",
    image: "forms-demo-1",
    ext: "jpg",
    link: "canvalab",
  },
  {
    title: "alan-jackson-title",
    description: "alan-jackson-description",
    image: "forms-demo-2",
    ext: "jpg",
    link: "alanjackson_pinlight",
  },
  {
    title: "highgate-title",
    description: "highgate-description",
    image: "forms-demo-3",
    ext: "jpg",
    link: "highgate_school",
  },
  {
    title: "david-lawrence-title",
    description: "david-lawrence-description",
    image: "forms-demo-4",
    ext: "jpg",
    link: "david_lawrence",
  },
  {
    title: "av-studio-title",
    description: "av-studio-description",
    image: "forms-demo-5",
    ext: "jpg",
    link: "art_video",
  },
  {
    title: "FTJ Group",
    description: "ftj-group-description",
    image: "forms-demo-6",
    ext: "jpg",
    link: "ftj",
  },
  {
    title: "medical-center-title",
    description: "medical-center-description",
    image: "forms-demo-7",
    ext: "jpg",
    link: "pulsecenter",
  },
];

export const examplePagesListHe = [
  {
    title: "canvalab-title",
    description: "canvalab-description",
    image: "08",
    ext: "jpg",
    link: "canvalab_he",
  },
  {
    title: "alan-jackson-title",
    description: "alan-jackson-description",
    image: "demo_5 - Alan Jackson",
    ext: "jpg",
    link: "alanjackson_pinlight",
    forceEn: true,
  },
  {
    title: "highgate-title",
    description: "highgate-description",
    image: "demo_6 - Highgate school",
    ext: "jpg",
    link: "highgate_school",
    forceEn: true,
  },
  {
    title: "david-lawrence-title",
    description: "david-lawrence-description",
    image: "demo_7 - David Lawrence",
    ext: "jpg",
    link: "david_lawrence",
    forceEn: true,
  },
  {
    title: "av-studio-title",
    description: "av-studio-description",
    image: "07",
    ext: "png",
    link: "art_video_he",
  },
  {
    title: "ftj-group-title",
    image: "06",
    ext: "jpg",
    description: "ftj-group-description",
    link: "ftj_he",
  },
  {
    title: "medical-center-title",
    image: "05",
    ext: "jpg",
    description: "medical-center-description",
    link: "pulsecenter_he",
  },
];
